var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.956 14.97h-2.94l-.462 1.33h-1.89l2.7-7.29h2.241l2.7 7.29h-1.889l-.459-1.328zm-2.47-1.352h1.996l-.996-2.9-1 2.9zm5.702-4.917h1.749V16.3h-1.749V8.7zm5.347.576v1.553h1.802v1.25h-1.802v2.32q0 .38.152.517.15.132.6.132h.899v1.25h-1.5q-1.035 0-1.47-.43-.429-.434-.429-1.47V12.08h-.869v-1.25h.87V9.277h1.747z",
    fontWeight: 700,
    fontSize: 10,
    fontFamily: "DejaVu Sans",
    letterSpacing: 0,
    wordSpacing: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlt);
export default __webpack_public_path__ + "static/media/alt.053e88a49995778eb78ac990801096aa.svg";
export { ForwardRef as ReactComponent };